import { ListItem, ListItemIcon, Stack, Typography, Divider } from '@mui/material'
import * as DropdownMenuRadix from '@radix-ui/react-dropdown-menu'
import React, { FC, ReactNode } from 'react'
import { IconType } from 'react-icons'
import { useNavigate } from 'react-router-dom'

interface DropdownItem {
  name: string
  icon: IconType
  route?: string
  action?: () => void
}

export interface DropdownSection {
  items: DropdownItem[]
}

interface DropdownMenuProps {
  trigger: ReactNode
  sections: DropdownSection[]
}

const DropdownMenu: FC<DropdownMenuProps> = ({ trigger, sections }) => {
  const navigate = useNavigate()

  return (
    <DropdownMenuRadix.Root>
      <DropdownMenuRadix.Trigger asChild>{trigger}</DropdownMenuRadix.Trigger>
      <DropdownMenuRadix.Portal>
        <Stack
          zIndex={5}
          component={DropdownMenuRadix.Content}
          borderRadius={1}
          align="end"
          style={{
            boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)',
            marginRight: '0px',
            marginLeft: '0px',
            marginTop: '0px',
            top: '0px',
            minWidth: '150px',
            backdropFilter: 'blur(100px)',
          }}
        >
          <Stack p={0.5} component={DropdownMenuRadix.DropdownMenuGroup}>
            {sections.map(({ items }, index) => (
              <div key={index}>
                {index !== 0 && <Divider sx={{ my: 0.5 }} variant="middle" />}
                {items.map(({ icon: Icon, name, route, action }, index) => (
                  <DropdownMenuRadix.DropdownMenuItem key={index}>
                    <ListItem
                      sx={{ ':hover': { bgcolor: '#7A7E8B' }, px: 1 }}
                      onClick={() => {
                        route && navigate(route)
                        action?.()
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: 'auto', mr: 1 }}>
                        <Icon size={16} color="white" />
                      </ListItemIcon>
                      <Typography fontSize={15}>{name}</Typography>
                    </ListItem>
                  </DropdownMenuRadix.DropdownMenuItem>
                ))}
              </div>
            ))}
          </Stack>
        </Stack>
      </DropdownMenuRadix.Portal>
    </DropdownMenuRadix.Root>
  )
}

export default DropdownMenu
